import type { UserContextDto, UserDto } from "@/types/auth";
import type { AdminUserListDto, UserFilterParams } from "@/types/admin-user.dto";
import type { ApiResponse, PagedResponseDto } from "@/types/common";
import type { CustomerMemberProfileDto } from "@/types/customer.dto";
import { apiClient, unwrapApiResponse } from "./httpClient";

export const usersService = {
  getMyContext(): Promise<UserContextDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<UserContextDto>>("/Users/me/context"));
  },

  getProfile(): Promise<UserDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<UserDto>>("/Users/profile"));
  },

  updateProfile(dto: UserDto): Promise<UserDto> {
    return unwrapApiResponse(apiClient.put<ApiResponse<UserDto>>("/Users/profile", dto));
  },

  getAdminUsers(params: UserFilterParams = {}): Promise<PagedResponseDto<AdminUserListDto>> {
    return unwrapApiResponse(
      apiClient.get<ApiResponse<PagedResponseDto<AdminUserListDto>>>("/Users", { params }),
    );
  },

  updateUserStatus(userId: string, isActive: boolean): Promise<boolean> {
    return unwrapApiResponse(
      apiClient.patch<ApiResponse<boolean>>(`/Users/${userId}/status`, { isActive }),
    );
  },

  adminActivateMember(userId: string): Promise<unknown> {
    return unwrapApiResponse(apiClient.post<ApiResponse<unknown>>(`/Users/${userId}/member/activate`));
  },

  getCustomerMemberProfile(userId: string): Promise<CustomerMemberProfileDto> {
    return unwrapApiResponse(apiClient.get<ApiResponse<CustomerMemberProfileDto>>(`/Users/${userId}/member`));
  },

  verifyUserKyc(userId: string, approve: boolean, rejectionReason?: string): Promise<unknown> {
    return unwrapApiResponse(
      apiClient.put<ApiResponse<unknown>>(`/Users/${userId}/kyc/verify`, {
        approve,
        rejectionReason,
      }),
    );
  },
};
